import React from 'react';
import * as S from '../DetailCardLoader/DetailCardLoader.styles';

const DetailCardLoader = () => (
  <S.DetailCardLoaderWrapDiv>
    <S.DetailCardLoaderGalleryBlock>
      <S.GalleryLoadWrap>
        <S.HotelGalleryBlockDiv />
        <S.TravellerGalleryBlockDiv>
          <S.TravellerGalleryInnerTopDiv></S.TravellerGalleryInnerTopDiv>
          <S.TravellerGalleryInnerBottomDiv></S.TravellerGalleryInnerBottomDiv>
        </S.TravellerGalleryBlockDiv>
      </S.GalleryLoadWrap>
      <S.HotelAboutLoader>
        <S.HotelHeadLoad />
        <S.LineSmallLoadOneThirdDiv />
        <S.LineSmallLoadHalfDiv />
        <S.SpacingTopDiv>
          <S.LineSmallLoadFullDiv />
          <S.LineSmallLoadOneThirdDiv />
          <S.LineSmallLoadFullDiv />
          <S.LineSmallLoadOneThirdDiv />
          <S.LineSmallLoadFullDiv />
          <S.LineSmallLoadOneThirdDiv />
        </S.SpacingTopDiv>
      </S.HotelAboutLoader>
    </S.DetailCardLoaderGalleryBlock>

    <S.DetailCardLoaderPricingBlock>
      <S.GuestLikeOuterWrapDiv>
        <S.GuestLikeInnerWrapDiv>
          <S.GuestLikeHeadLoadWrap>
            <S.GuestLikeHeaderLoaderSpan />
          </S.GuestLikeHeadLoadWrap>
          <S.GuestLikeHeaderLoaderWrapDiv>
            <S.LeftSideInfoLoader>
              <S.LineSmallLoadFullDiv />
              <S.LineSmallLoadHalfDiv />

              <S.SpacingTopDiv>
                <S.LineSmallLoadFullDiv />
                <S.LineSmallLoadHalfDiv />
              </S.SpacingTopDiv>

              <S.SpacingTopDiv>
                <S.LineSmallLoadFullDiv />
                <S.LineSmallLoadHalfDiv />
              </S.SpacingTopDiv>
            </S.LeftSideInfoLoader>
            <S.RightSideInfoLoader>
              <S.LineSmallLoadOneThirdDiv />
              <S.LineSmallLoadHalfDiv />
            </S.RightSideInfoLoader>
          </S.GuestLikeHeaderLoaderWrapDiv>
          <S.ButtonLoader>
            <S.LoadButton></S.LoadButton>
          </S.ButtonLoader>
        </S.GuestLikeInnerWrapDiv>
      </S.GuestLikeOuterWrapDiv>
      <S.SignUpOuterWrapDiv>
        <S.SignUpOuterFirstWrapDiv>
          <S.SignUpOuterFirstWraptextDiv>
            <S.LineSmallLoadOneThirdDiv />
            <S.LineSmallLoadHalfDiv />
            <S.SpacingLargeTopDiv>
              <S.LineSmallLoadOneThirdDiv />
              <S.LineSmallLoadHalfDiv />
            </S.SpacingLargeTopDiv>
          </S.SignUpOuterFirstWraptextDiv>
          <S.SignUpOuterFirstWrapimageDiv></S.SignUpOuterFirstWrapimageDiv>
        </S.SignUpOuterFirstWrapDiv>
        <S.SignUpOuterSecondWrapDiv>
          <S.LineSmallLoadFullDiv />
          <S.LineSmallLoadOneThirdDiv />
          
          <S.GiftCardWrapDiv />

          <S.LineSmallLoadFullDiv />
          <S.LineSmallLoadOneThirdDiv />
        </S.SignUpOuterSecondWrapDiv>
      </S.SignUpOuterWrapDiv>
    </S.DetailCardLoaderPricingBlock>
  </S.DetailCardLoaderWrapDiv>
);

export default DetailCardLoader;
